class ImagesContentSlider extends HTMLElement {
  constructor() {
    super();

    this.elements = {};
    this.$slider = null;
    this.settings = {
      slidesToShow: parseFloat(this.getAttribute("data-slides-to-show")),
    };
  }

  connectedCallback() {
    this.initSlick();
  }

  initSlick() {
    this.$slider = $(this).slick({
      dots: false,
      slidesToShow: this.settings.slidesToShow,
      dots: true,
      arrows: true,
      infinite: false,
      nextArrow:
        '<span class="slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
      prevArrow:
        '<span class="slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.33,
          },
        },
      ],
    });

    this.elements = {
      dots: this.querySelector(".slick-dots"),
    };
  }
}

if (customElements.get("images-content-slider") === undefined) {
  customElements.define("images-content-slider", ImagesContentSlider);
}
